import { Link, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { 
  LayoutDashboard, 
  Users, 
  MessageSquare, 
  Ruler, 
  BarChart3, 
  Settings, 
  LogOut 
} from 'lucide-react';

const DashboardLayout = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const navItems = [
    { path: '/dashboard', label: 'Overview', icon: LayoutDashboard },
    { path: '/dashboard/leads', label: 'Leads', icon: Users },
    { path: '/dashboard/social', label: 'Social Posts', icon: MessageSquare },
    { path: '/dashboard/roof-measurement', label: 'Roof Measurement', icon: Ruler },
    { path: '/dashboard/reports', label: 'Reports', icon: BarChart3 },
    { path: '/dashboard/settings', label: 'Settings', icon: Settings },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <aside className="fixed left-0 top-0 h-full w-64 bg-secondary border-r-4 border-primary">
        <div className="p-6 border-b-2 border-gray-700">
          <img 
            src="https://customer-assets.emergentagent.com/job_rejuv-hyper-local/artifacts/wdpxrhtp_35A5B7C9-E791-468D-BB13-60EF0C8B0415.png" 
            alt="Savage" 
            className="h-12 w-auto mb-2"
          />
          <p className="text-white text-sm font-manrope">Growth OS</p>
        </div>
        
        <nav className="p-4 space-y-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-sm font-manrope font-semibold transition-colors ${
                  isActive
                    ? 'bg-primary text-white'
                    : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                }`}
              >
                <Icon className="h-5 w-5" />
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="absolute bottom-0 left-0 right-0 p-4 border-t-2 border-gray-700">
          <div className="text-white mb-3">
            <p className="font-manrope font-semibold">{user?.full_name}</p>
            <p className="text-sm text-gray-400">{user?.email}</p>
          </div>
          <Button
            onClick={logout}
            className="w-full bg-red-600 hover:bg-red-700 text-white"
          >
            <LogOut className="h-4 w-4 mr-2" />
            Logout
          </Button>
        </div>
      </aside>

      <main className="ml-64 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
